/**
 * The automatic-opens caveat, worded once (#369).
 *
 * Apple Mail Privacy Protection, and some other clients and security scanners,
 * fetch the tracking pixel without a person reading the mail, so every open
 * count and open rate runs high. The product owner's call on #369 was to keep
 * opens visible but say so wherever one appears; one string means the wording
 * cannot drift between screens and a test can look for it.
 */
export const AUTO_OPENS_CAVEAT =
  "Opens are inflated by automatic opens (e.g. Apple Mail Privacy Protection), so treat open counts and open rates as a trend, not an exact figure.";

export function AutoOpensNote() {
  return <p className="muted" style={{ margin: "8px 0 0" }}>{AUTO_OPENS_CAVEAT}</p>;
}
